import { render, staticRenderFns } from "./VideoS.vue?vue&type=template&id=14d8e856&scoped=true"
import script from "./VideoS.vue?vue&type=script&lang=js"
export * from "./VideoS.vue?vue&type=script&lang=js"
import style0 from "./VideoS.vue?vue&type=style&index=0&id=14d8e856&prod&scoped=true&lang=scss"
import style1 from "./VideoS.vue?vue&type=style&index=1&id=14d8e856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d8e856",
  null
  
)

export default component.exports